import { GFormSejour, GFormSejourEvents } from '@scripts/gform-sejour/g-form-sejour.js';

export class TrackingManager {
    static instance;

    constructor () {
        if (TrackingManager.instance) {
            return TrackingManager.instance;
        }

        TrackingManager.instance = this;
        this.bindEvents();
    }

    bindEvents () {
        window.addEventListener(`${GFormSejour.EventPrefix}-${GFormSejourEvents.PAGE_CHANGE}`, (event) => this.handlePageChange(event.detail));
    }

    /**
     * Handle the page change event in the Gravity Form
     *
     * @param {page: number} page
     */
    handlePageChange ({ page }) {
        window.dataLayer = window.dataLayer || [];

        const form = document.querySelector('form[id^="gform_"]');
        const formId = form?.id.replace('gform_', '');

        window.dataLayer.push({
            event: 'gravity_form_page_change',
            reservation: {
                formId,
                page
            }
        });
    }
}
